import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField, Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const AnnualReportThemeHero = ({ entity, withLink }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = entity.getIn(['name', 0, 'value'], '');
  const subtitle = entity.getIn(['field_title', 0, 'value'], null);
  const body = entity.getIn(['description', 0, 'processed']);
  const path = entity.getIn(['paths', currentLanguage]);

  return (
    <div className="AnnualReportThemeHero active-theme-background-color">
      <Container>
        <h1 className="AnnualReportThemeHero__title">{title}</h1>
        <div className="AnnualReportThemeHero__content">
          {subtitle && (
            <h2>{subtitle}</h2>
          )}
          <div className="row">
            <div className="col-12 col-sm-8 col-xl-6">
              <WysiwygField
                property="schema:text"
                html={body}
              />
              {withLink && (
                <CoreLink className="Button Button--secondary" to={path}>
                  {t('general.visit_theme')} <i className="icon icon-arrow-right icon-variant-1" />
                </CoreLink>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AnnualReportThemeHero;
